import { Post } from '../requestBuilder/buildFetchRequest';
import ChangeExpiredPasswordRequest from './ChangeExpiredPasswordRequest';
import ChangeForgottenPasswordRequest from './ChangeForgottenPasswordRequest';
import ChangeForgottenPasswordResponse from './ChangeForgottenPasswordResponse';
import ChangePasswordRequest from './ChangePasswordRequest';
import ChangePasswordResponse from './ChangePasswordResponse';
import ForgotPasswordRequest from './ForgotPasswordRequest';
import ForgotPasswordResponse from './ForgotPasswordResponse';
import LoginRequest from './LoginRequest';
import LoginResponse from './LoginResponse';
import LogOffResponse from './LogOffResponse';
import TestAuthResponse from './TestAuthResponse';

export const login = (request: LoginRequest) : Promise<LoginResponse> => (
  Post('/api/auth/login')
    .AddBody({
      userName: request.userName,
      password: request.password,
    })
    .Execute()
);

export const logoff = () : Promise<LogOffResponse> => (
  Post('/api/auth/logoff')
    .Execute()
);

export const testAuth = () : Promise<TestAuthResponse> => (
  Post('/api/auth/isAuthenticated')
    .Execute()
);

export const changePassword = (request: ChangePasswordRequest): Promise<ChangePasswordResponse> => (
  Post('/api/auth/ChangePassword')
    .AddBody({
      oldassword: request.oldPassword,
      newPassword: request.newPassword,
      newPasswordConfirmation: request.newPasswordConfirmation,
    })
    .Execute()
);

export const changeExpiredPassword = (request: ChangeExpiredPasswordRequest): Promise<ChangePasswordResponse> => (
  Post('/api/auth/ChangeExpiredPassword')
    .AddBody({
      userName: request.userName,
      oldPassword: request.oldPassword,
      newPassword: request.newPassword,
      newPasswordConfirmation: request.newPasswordConfirmation,
    })
    .Execute()
);

export const forgotPassword = (request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => (
  Post('/api/auth/ForgotPassword')
    .AddBody({
      userName: request.userName,
    })
    .Execute()
);

export const changeForgottenPassword = (request: ChangeForgottenPasswordRequest): Promise<ChangeForgottenPasswordResponse> => (
  Post('/api/auth/ChangeForgottenPassword')
    .AddBody({
      passcode: request.passcode,
      password: request.password,
      newPassword: request.newPassword,
      userName: request.userName,
    })
    .Execute()
);
